'use strict';

/**
 * @fileoverview `@puffin-core/read-only` — the ONE read-only toolkit (MUTATION-INSTRUMENT-001
 * F-TOCONTAIN-2): `ReadOnlySet`, `ReadOnlyMap` and `deepFreeze`.
 *
 * @module @puffin-core/read-only
 */

const { ReadOnlySet } = require('./readOnlySet');
const { ReadOnlyMap } = require('./readOnlyMap');
const { deepFreeze } = require('./deepFreeze');

module.exports = { ReadOnlySet, ReadOnlyMap, deepFreeze };
